import { styled } from "@mui/material"

export const StyledFormativeEndQuestionContainer = styled("div")`
  padding: 1em;
`
